import { createBrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

/**
 * Sentry-wrapped createBrowserRouter for React Router v7
 * Enables automatic performance tracking for route navigation
 */
export const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
